/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState } from 'react' // eslint-disable-line

import { Drawer, Button, Tabs, message, Divider, Col, Row, Spin } from 'antd'
import Markdown from 'react-markdown'

import BusinessStatus from '../../business/status'
import * as MachineUtils from '../../business/machine.utils'
import StatusTag from '../../components/StatusTag'

import { machineAction } from '../../action/machine'
import { agentAction } from '../../action/agent'
import { ViewerStyles } from './styles'
import { Machine } from '../../business/define'

import { listLoader } from '../../store/list/ListLoader'

import * as ContextUtils from '../../utils/context'
import MachineAttributeDrawer from './MachineAttributeDrawer'
import MachineEditDrawer from './MachineEditDrawer'

const { TabPane } = Tabs

const DescriptionItem = (props: any) => (
  <div css={ViewerStyles.description}>
    <p className="viewer-title">
      {props.title}:
    </p>
    {props.content}
  </div>
)

export default (props: any) => {
  const [machine, onMachineChange] = useState<Machine>(null)
  const [attribute, onMachineAttributeChange] = useState<any>(null)
  const [visible, onVisibleChange] = useState(false)
  const [loading, onLoadChange] = useState(false)

  const loadMachineData = () => {
    onLoadChange(true)
    machineAction
      .fetchMachineInfo(props['machine_id'])
      .then((responseData: any) => {
        onMachineChange(responseData.machine)
        onMachineAttributeChange(responseData.attribute)
        onVisibleChange(true)
        onLoadChange(false)
      })
      .catch((err: Error) => {
        onLoadChange(false)
        message.warning(err.message)
      })
  }

  const onClickButton = () => {
    loadMachineData()
  }

  const onChangeMachineStatus = (machineId: any, action: string) => {
    machineAction.publishMachine(machineId, action)
      .then(responseData => {
        message.info(`设置机器状态成功:${action}`)
        listLoader.reloadListPage()
        loadMachineData()
      })
      .catch((err) => {
        message.warning(err.message)
      })
  }

  const onBindMachine = (machineId: any) => {
    agentAction.bindMachine(machineId)
      .then(responseData => {
        message.info('机器绑定请求发送成功')
        listLoader.reloadListPage()
        loadMachineData()
      })
      .catch((err) => {
        message.warning(err.message)
      })
  }

  return (
    <div css={ViewerStyles["data-drawer"]}>
      <Button type="link" onClick={onClickButton}>
        {props['machine_id']}
      </Button>
      {
        machine && <Drawer
          width="420"
          title={`机器[${machine.id}]`}
          placement="right"
          onClose={() => {
            onVisibleChange(false)
          }}
          visible={visible}
        >
          <div css={ViewerStyles["drawer-container"]}>
            <Spin spinning={loading}>
              <div css={ViewerStyles["drawer-body"]}>
                <p><MachineEditDrawer record={machine} text="修改" onLoadChange={() => {
                  loadMachineData()
                  listLoader.reloadListPage()
                }} /></p>
                <p css={ViewerStyles.title}>机器管理 <StatusTag item={machine} status={machine.status} config={BusinessStatus.machine} /></p>
                <Row>
                  <Col span={12}>
                    <DescriptionItem title="机器价格" content={machine['price']} />
                  </Col>
                  <Col span={12}>
                    <DescriptionItem title="GPU数量" content={machine['unit']} />
                  </Col>
                </Row>
                <Divider />
                <Tabs defaultActiveKey="machine">
                  <TabPane tab="机器信息" key="machine">
                    <Markdown source={ContextUtils.buildJsonMarked(machine)} />
                  </TabPane>
                  {
                    attribute && <TabPane tab="机器属性" key="attribute">
                      {machine.status > 0 && <MachineAttributeDrawer text="编辑" record={machine} attribute={attribute} />}
                      <div style={{ marginTop: '6px' }}>
                        <Markdown source={ContextUtils.buildJsonMarked(attribute)} />
                      </div>
                    </TabPane>
                  }
                </Tabs>
              </div>
              <div css={ViewerStyles["drawer-footer"]}>
                {
                  MachineUtils.isMachineNeedSync(machine) &&
                  <Button
                    type="link"
                    size="small"
                    onClick={() => { onBindMachine(props.machine_id) }}
                  >绑定</Button>
                }
                <Button type="primary" onClick={() => { onChangeMachineStatus(props['machine_id'], 'publish') }}>上线</Button>
                <Button type="danger" onClick={() => { onChangeMachineStatus(props['machine_id'], 'hidden') }}>下线</Button>
              </div>
            </Spin>
          </div>
        </Drawer>
      }
    </div>
  )
}